import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import styled from 'styled-components';

export const InputContainer = styled.div`
    width: 100%;
    margin-bottom: 20px;
    position: relative;
    flex-direction: column;
`;

export const Input = styled.input`
    height: 48px;
    width: 100%;
    padding: 14px 0 14px 16px;
    ${FONTS.XS};
    color: ${COLORS.TextPrimary};
    border: 2px solid ${p => p.isNotValid ? COLORS.Error : COLORS.BgSecondary};
    border-radius: ${BorderRadius.componentRadius};
    transition: border 0.2s ease-in;
    outline: none;
    box-shadow: none;
    box-sizing: border-box;

    &:not(:placeholder-shown) {
        border-color: ${p => p.isNotValid ? COLORS.Error : COLORS.GRAY_LIGHT};
    }

    &:focus, &:hover {
        border-color: ${p => p.isNotValid ? COLORS.Error : COLORS.GRAY_DARK};
    }

    &:disabled {
        border-color: ${COLORS.BgSecondary};
        background-color: ${COLORS.BgSecondary};
        color: ${COLORS.TextDisabled};
    }

    &::placeholder {
        color: ${COLORS.TextDisabled};
    }

    &::-ms-clear,
    &::-ms-reveal,
    &:focus::-ms-clear, ::-ms-reveal {
        display: none !important;
    }

    &[type=number]::-webkit-inner-spin-button,
    &[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    -webkit-text-security: ${p => p.showText ? 'none' : 'disc'}!important;
`;

export const InputError = styled.p`
    display: block;
    ${FONTS.XXS};
    margin: 0;
    color: ${COLORS.Error};
    transition: opacity 0.2s ease-in-out;
`;
